<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col">
        <div class="row">
          <h2 class="card-title">{{ 'Seller.Bill_Payment.PayUsingQr'
            | translate}}:</h2>
        </div>
        <div class="row">
          <img class="card-img-overlay" src="{{ data.qrCodeUrl }}" alt="QR Image"
            load="https://dummyimage.com/300x300/cccccc/ffffff.png&text=Loading+QR" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <h5 class="card-text">{{ 'Seller.Bill_Payment.CanNotScanSendCollectRequest'
            | translate}}:</h5>
        </div>
        <form class="row p-3" [formGroup]="instapayForm" (submit)="submit()">
          <input class="form-control px-2" type="text" formControlName="ipa" placeholder="01## | ##@instapay" />
          <p class="text-danger my-1" *ngIf="errorMsg">
            {{errorMsg}}
          </p>
          <button type="submit" class="btn btn-primary mt-3" [disabled]="instapayForm.invalid || disableRequesting"> {{
            'Seller.Bill_Payment.Send'
            | translate}}</button>
          <button class="btn btn-danger mt-2" (click)="close()"> {{ 'Seller.Products.Cancel'
            | translate}}</button>
        </form>
      </div>
    </div>
  </div>

</div>
